// This file was automatically generated
module.exports = {
    "env": "prod",
    "apiBaseURL": "https://api.tasksharp.com",
    "sentryDSN": "https://6caa03bdb87444a991efe3dc6ec03934@sentry.io/126761",
    "emailManager": {
        "apiBaseURL": "https://em.tasksharp.com"
    }
};



// WEBPACK FOOTER //
// ./src/config/config.js